module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArUlEQVQ4T6WT0RHCMAxDpQ3YsO0GbAJsEDZkA3Pm3NYkMvQgf3GiZ9lxiD8XXW9mJwATydsRnpmdATSSjxXggUsEl08QM2ueDMBCsr0A4WI9cLKEJPGd5Oy6DfANosQDoIJUYgnoIVGh291s5x69lZAPUlYPS3HpoHPh27Kx0kGuOVz5s0nIAFANS7EBUj3jUHMFUYNUNkxB+lEuxWJi91GOzzSTvP70mY6IqjtPf0R4EeMlApkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/mobileclose.png
// module id = LPQJ
// module chunks = 1